import {takeEvery} from 'redux-saga/effects'
import {BULK_DELETE_ENTITIES} from 'setup/redux/Actions/General/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* bulkDeleteSaga() {
  yield takeEvery(BULK_DELETE_ENTITIES, fetchData)
}

export default bulkDeleteSaga
